import { useQuery } from '@tanstack/react-query';
import type { GeoPoint } from '@app/shared/geo';
import { api } from '../api';
import type { PlaceValue } from './placeDefaults';

/**
 * The warehouse (events module), for "ok. N km od magazynu" (no road factor, owner 2026-10-23), and the default place
 * of a new event (owner 2026-10-30 22:20; null = none; its parts the role does not see in events are left out).
 */
export type CompanySettings = { warehouseAddress?: string; warehousePoint?: GeoPoint | null; defaultPlace?: Partial<PlaceValue> | null; version: number; moved?: WarehouseMoved };
/** Review I2/I3: what a moved warehouse did (counts only, in the answer to saving). */
export type WarehouseMoved = { chosenCleared?: number; typedKept?: number; recounting: number };
export const COMPANY_KEY = ['events', 'settings'] as const;
export const SETTINGS_RESOURCE = 'events.settings';

export function useCompanySettings(enabled = true) {
  return useQuery({ queryKey: COMPANY_KEY, enabled, retry: false, staleTime: 60_000, queryFn: () => api<CompanySettings>('/api/events/settings') });
}

const inEvents = (n: number) => `w ${n} ${n === 1 ? 'wydarzeniu' : 'wydarzeniach'}`;

/** The notice after the warehouse moved: chosen routes to choose again, Google routes coming back, typed km to check. */
export function movedNotice(m: WarehouseMoved): string {
  return [
    'Magazyn przeniesiony.',
    m.chosenCleared ? `Wybrane trasy wyczyszczone ${inEvents(m.chosenCleared)} — wybierz je ponownie.` : '',
    m.recounting > 0 ? 'Trasy Google nadchodzących wydarzeń przeliczą się same (zakończone zostają bez tras).' : '',
    m.typedKept ? `Km wpisane ręcznie zostały ${inEvents(m.typedKept)} — sprawdź je.` : '',
  ]
    .filter(Boolean)
    .join(' ');
}
